import axios from 'axios';

import { type AutocompleteResult, type PlaceDetails } from '@jsmdg/google-places';
import { PlacesClient } from '@jsmdg/google-places/client';

const getLanguageFromLocale = (locale: string): string => locale.split('-')[0];

const placesClient = new PlacesClient({ basePath: '/api/places', httpClient: axios });

export const fetchPlacesSuggestions = async ({
    input,
    sessionToken,
    locale,
}: {
    input: string;
    sessionToken: string;
    locale: string;
}): Promise<AutocompleteResult> => {
    return placesClient.autocomplete({
        query: input,
        sessionToken,
        language: getLanguageFromLocale(locale),
    });
};

export const fetchPlacesDetail = async ({
    placeId,
    sessionToken,
    locale,
}: {
    placeId: string;
    sessionToken: string;
    locale: string;
}): Promise<PlaceDetails> => {
    return placesClient.details({
        placeId,
        sessionToken,
        language: getLanguageFromLocale(locale),
    });
};
